import type { ReducersMapObject } from 'redux';

import { subscriptionSlice } from '../subscription-model/subscription.slice';

// Add new slice reducers here, for use with combineReducers api
export const rootReducers: ReducersMapObject = {
    [subscriptionSlice.name]: subscriptionSlice.reducer
};
